<template>
  <div>
	<div class="gywmTwo">
		<img class="gywmTwo_img" :src="gywm.bgCover" />
		<div class="gywmTwo_dw">
			<div class="gywmTwo_dw_box">
				<div class="gywmTwo_dw_for" v-for="(item,index) in gywm.bgData" :key="index">
					<img :src="item.cover" class="gywmTwo_dw_for_img" />
					<div  class="gywmTwo_dw_for_wz">
						<div class="gywmTwo_dw_for_wz_name">
							{{item.title}}
						</div>
						<div class="gywmTwo_dw_for_wz_cen">
							{{item.desc}}
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		gywm:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.gywmTwo{
	position: relative;
	// margin-bottom: 185px;
	.gywmTwo_img{
		width: 100%;
		height: 800px;
		object-fit: cover;
	}
	.gywmTwo_dw{
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height:100%;
		display: flex;
		align-items: center;
		justify-content: center;
		.gywmTwo_dw_box{
			width: 1200px;
			display: flex;
			.gywmTwo_dw_for{
				position: relative;
				width: 400px;
				height: 260px;
				.gywmTwo_dw_for_img{
					width: 400px;
					height: 260px;
					object-fit: contain;
				}
				.gywmTwo_dw_for_wz{
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height:100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					.gywmTwo_dw_for_wz_name{
						font-size: 26px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #FFFFFF;
						margin-bottom: 30px;
						text-align: center;
					}
					.gywmTwo_dw_for_wz_cen{
						text-align: center;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #FFFFFF;
					}
				}
			}
		}
	}
}
@media screen and (max-width:1200px) {
	.gywmTwo_dw_box{
		width: 100% !important;
		flex-wrap: wrap;
		.gywmTwo_dw_for{
			width: 100% !important;
			.gywmTwo_dw_for_img{
				width: 100% !important;
			}
		}
	}
}
</style>
